import React, { useState } from "react";
import "../Styles/style.css";
import { Box, Modal } from "@mui/material";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Waiting from "../../images/clock.json";
import Lottie from "lottie-react";
import PaymentSuccess from "../modals/payment-success";
import Confirm from "../../images/blue-tick-success.png";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

const BoostAd = () => {
  const { user } = React.useContext(AuthContext);
  const token = localStorage.getItem("token");
  const history = useHistory();
  const url = window.location.href;

  const [packageId, setPackageId] = React.useState(4);
  const [packages, setPackages] = React.useState([]);
  const [errOpen, setErrOpen] = React.useState(false);
  const [value, setValue] = useState(950);
  const [successIsOpen, setSuccessIsOpen] = React.useState(false);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [tokenResponse, setTokenResponse] = useState(null);
  const [randomNo, setRandomNo] = useState("");
  const [paymentResponse, setPaymentResponse] = useState({});
  const [openFaildModal, setOpenFaildModal] = useState(false);
  const [openWaitingModal, setOpenWaitingModal] = useState(false);
  const [packageInfo, setPackageInfo] = useState({});
  const [featurePackageSuccess, setFeaturePackageSuccess] = useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    //PayFast Parameters
    const responseCode = params.get("err_code");
    const responseMessage = params.get("err_msg");
    const responseAmount = params.get("transaction_amount");
    const responseTransactionId = params.get("transaction_id");
    const responseBasketId = params.get("basket_id");

    if (params?.size > 0) {
      if (
        responseCode === "000" ||
        responseCode === "200" ||
        responseCode === "121"
      ) {
        if (
          responseCode &&
          responseAmount &&
          responseTransactionId &&
          responseBasketId
        ) {
          getBoostUpdate(
            responseAmount,
            responseTransactionId,
            responseBasketId
          );

          setPaymentResponse({
            responseMessage,
            responseAmount,
            responseTransactionId,
            responseBasketId,
          });
        }
      } else if (
        responseCode === "002" ||
        responseCode === "001" ||
        responseCode === "97" ||
        responseCode === "106" ||
        responseCode === "3" ||
        responseCode === "14" ||
        responseCode === "54" ||
        responseCode === "13" ||
        responseCode === "126" ||
        responseCode === "75" ||
        responseCode === "14" ||
        responseCode === "15" ||
        responseCode === "42" ||
        responseCode === "423" ||
        responseCode === "41" ||
        responseCode === "801" ||
        responseCode === "802" ||
        responseCode === "803" ||
        responseCode === "804" ||
        responseCode === "805" ||
        responseCode === "806" ||
        responseCode === "807" ||
        responseCode === "808" ||
        responseCode === "809" ||
        responseCode === "810" ||
        responseCode === "811" ||
        responseCode === "812" ||
        responseCode === "813" ||
        responseCode === "850" ||
        responseCode === "851" ||
        responseCode === "79" ||
        responseCode === "901" ||
        responseCode === "9000" ||
        responseCode === "100827"
      ) {
        if (
          responseCode &&
          responseAmount &&
          responseTransactionId &&
          responseBasketId &&
          responseMessage
        ) {
          setPaymentResponse({
            responseMessage,
            responseAmount,
            responseTransactionId,
            responseBasketId,
          });
        }
        setOpenFaildModal(true);

        setTimeout(() => {
          setOpenFaildModal(false);
        }, 4000);
      } else {
      }
    }
  }, []);

  const getBoostUpdate = async (
    responseAmount,
    responseTransactionId,
    responseBasketId
  ) => {
    try {
      setOpenWaitingModal(true);
      const response = await axios.get(`${baseUrl}/purchaseboostaddpackage`, {
        params: {
          boostbundle_id: responseBasketId,
          payment_method: "PayFast",
          security_deposit: responseAmount,
          payment_token: responseTransactionId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOpenWaitingModal(false);
      setSuccessIsOpen(true);
      setTimeout(() => {
        setSuccessIsOpen(false);
        history.push(`/my-ads`);
      }, 4000);
    } catch (error) {
      setErrOpen(true);
      setOpenWaitingModal(false);
      setTimeout(() => {}, 3000);
      console.error(error);
    }
  };
  const generateRandomNumber = () => {
    const min = 1;
    const max = 1000;
    const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    setRandomNo(randomNum);
  };
  const getAccessToken = async () => {
    try {
      const response = await axios.get(`${baseUrl}/gettoken`, {
        params: {
          BASKET_ID: packageId + "-" + randomNo,
          CURRENCY_CODE: "PKR",
          TXNAMT: 5,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setTokenResponse(response?.data);
      setTokenLoading(true);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    if (!randomNo) {
      generateRandomNumber();
    }
    if (user) {
      getAccessToken();
    }
  }, [user, value]);

  const fetchPackages = async () => {
    try {
      const response = await axios.get(`${baseUrl}/boostaddpackagelist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPackages(response?.data?.data);
    } catch (error) {
      console.error("Error fetching packages", error);
    }
  };
  React.useEffect(() => {
    fetchPackages();
  }, []);

  const handlePayFastFormSubmit = () => {
    const form = document.createElement("form");
    form.method = "POST";
    form.id = "PayFast_payment_form";
    form.name = "PayFast-payment-form";
    form.action =
      "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction";

    const CURRENCYCODE = document.createElement("input");
    CURRENCYCODE.type = "hidden";
    CURRENCYCODE.name = "CURRENCY_CODE";
    CURRENCYCODE.value = "PKR";
    form.appendChild(CURRENCYCODE);

    const MERCHANTID = document.createElement("input");
    MERCHANTID.type = "hidden";
    MERCHANTID.name = "MERCHANT_ID";
    MERCHANTID.value = 20579;
    form.appendChild(MERCHANTID);

    const MERCHANTNAME = document.createElement("input");
    MERCHANTNAME.type = "hidden";
    MERCHANTNAME.name = "MERCHANT_NAME";
    MERCHANTNAME.value = "Fame Wheel";
    form.appendChild(MERCHANTNAME);

    const ACCESSTOKEN = document.createElement("input");
    ACCESSTOKEN.type = "hidden";
    ACCESSTOKEN.name = "TOKEN";
    ACCESSTOKEN.value = tokenResponse?.ACCESS_TOKEN;
    form.appendChild(ACCESSTOKEN);

    const BASKETID = document.createElement("input");
    BASKETID.type = "hidden";
    BASKETID.name = "BASKET_ID";
    BASKETID.value = `${packageId}-${randomNo}`;
    form.appendChild(BASKETID);

    const TXNAMTInput = document.createElement("input");
    TXNAMTInput.type = "hidden";
    TXNAMTInput.name = "TXNAMT";
    TXNAMTInput.value = 5;
    form.appendChild(TXNAMTInput);

    const ORDERDATE = document.createElement("input");
    ORDERDATE.type = "hidden";
    ORDERDATE.name = "ORDER_DATE";
    ORDERDATE.value = tokenResponse?.GENERATED_DATE_TIME;
    form.appendChild(ORDERDATE);

    const SUCCESSURL = document.createElement("input");
    SUCCESSURL.type = "hidden";
    SUCCESSURL.name = "SUCCESS_URL";
    SUCCESSURL.value = `${url}`;
    form.appendChild(SUCCESSURL);

    const FAILUREURL = document.createElement("input");
    FAILUREURL.type = "hidden";
    FAILUREURL.name = "FAILURE_URL";
    FAILUREURL.value = `${url}`;
    form.appendChild(FAILUREURL);

    const CHECKOUTURL = document.createElement("input");
    CHECKOUTURL.type = "hidden";
    CHECKOUTURL.name = "CHECKOUT_URL";
    CHECKOUTURL.value = "https://www.famewheels.com/";
    form.appendChild(CHECKOUTURL);

    const CUSTOMEREMAIL = document.createElement("input");
    CUSTOMEREMAIL.type = "hidden";
    CUSTOMEREMAIL.name = "CUSTOMER_EMAIL_ADDRESS";
    CUSTOMEREMAIL.value = user?.email;
    form.appendChild(CUSTOMEREMAIL);

    const CUSTOMERMOBILENO = document.createElement("input");
    CUSTOMERMOBILENO.type = "hidden";
    CUSTOMERMOBILENO.name = "CUSTOMER_MOBILE_NO";
    CUSTOMERMOBILENO.value = user?.phone;
    form.appendChild(CUSTOMERMOBILENO);

    const SOMERANDOMSTRING = document.createElement("input");
    SOMERANDOMSTRING.type = "hidden";
    SOMERANDOMSTRING.name = "SIGNATURE";
    SOMERANDOMSTRING.value = "SOMERANDOM-STRING";
    form.appendChild(SOMERANDOMSTRING);

    const MERCHANTCART = document.createElement("input");
    MERCHANTCART.type = "hidden";
    MERCHANTCART.name = "VERSION";
    MERCHANTCART.value = "MERCHANTCART-0.1";
    form.appendChild(MERCHANTCART);

    const TXNDESCInput = document.createElement("input");
    TXNDESCInput.type = "hidden";
    TXNDESCInput.name = "TXNDESC";
    TXNDESCInput.value = "Item Purchased from Cart";
    form.appendChild(TXNDESCInput);

    const PROCCODEInput = document.createElement("input");
    PROCCODEInput.type = "hidden";
    PROCCODEInput.name = "PROCCODE";
    PROCCODEInput.value = "00";
    form.appendChild(PROCCODEInput);

    const ECOMMPURCHASE = document.createElement("input");
    ECOMMPURCHASE.type = "hidden";
    ECOMMPURCHASE.name = "TRAN_TYPE";
    ECOMMPURCHASE.value = "ECOMM_PURCHASE";
    form.appendChild(ECOMMPURCHASE);

    const STOREID = document.createElement("input");
    STOREID.type = "hidden";
    STOREID.name = "STORE_ID";
    STOREID.value = "";
    form.appendChild(STOREID);

    const RECURRINGTXN = document.createElement("input");
    RECURRINGTXN.type = "hidden";
    RECURRINGTXN.name = "RECURRING_TXN";
    RECURRINGTXN.value = "TRUE";
    form.appendChild(RECURRINGTXN);

    document.body.appendChild(form);
    form.submit();
  };

  const successClose = () => {
    setSuccessIsOpen(false);
  };

  return (
    <>
      <PaymentSuccess
        open={successIsOpen}
        onClose={successClose}
        response={paymentResponse}
      />
      <div className=" container p-3 p-md-4">
        <h5 className="mt-3 text-black fw-600 text-center">
          Want to Sell Your Vehicle Faster?
        </h5>

        <div className="row d-flex justify-content-center align-items-center my-3">
          <div className="col-lg-2">
            <img
              src="https://wsa3.pakwheels.com/assets/get-featured-car-e4cd11ec4696af67a5d5c4b4288fec64.svg"
              alt="feature-img"
            />
          </div>

          <div className="col-lg-6">
            <div className="d-flex gap-3 align-items-center">
              <i className="fa-solid fa-check text-success"></i>
              <span className="fontSm">Reach up to 10x times more buyers</span>
            </div>

            <div className="d-flex gap-3 align-items-center my-2">
              <i className="fa-solid fa-check text-success"></i>
              <span className="fontSm">Show your Ad in top position</span>
            </div>

            <div className="d-flex gap-3 align-items-center">
              <i className="fa-solid fa-check text-success"></i>
              <span className="fontSm">Be at the Top, and get noticed</span>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {packages &&
            packages.map((data) => (
              <div
                key={data?.boostbundle_id}
                id={data?.boostbundle_id}
                className={`col-lg-5 ${
                  packageId === data?.boostbundle_id
                    ? "bgLightRed border border-danger"
                    : "border border-black-50"
                } p-3 rounded m-1 `}
                onClick={() => {
                  setPackageInfo(data);
                  setPackageId(data?.boostbundle_id);
                  setValue(data?.boostbundle_price);
                }}
              >
                <div className="d-flex justify-content-between">
                  <div className="mb-3">
                    <div className="d-flex gap-3">
                      <input
                        type="radio"
                        className="form-check-input"
                        id={data?.boostbundle_id}
                        name="car"
                        defaultChecked={
                          packageId === data?.boostbundle_id ? true : false
                        }
                      />

                      <div className="d-flex gap-3">
                        <h5 className="text-black fs-5 text-capitalize">
                          {data?.boostbundle_name}
                        </h5>
                        {data?.boostbundle_id === 4 && (
                          <p className="contactSellerBtn text-white py-1 px-2 rounded m-0">
                            Recommended
                          </p>
                        )}
                      </div>
                    </div>
                    <p className="text-black-50 fontSm m-0 p-0">
                      {data?.featureaddpricing_description}
                    </p>
                  </div>

                  <p className="text-black fw-600">
                    PKR {data?.boostbundle_price}
                  </p>
                </div>
              </div>
            ))}

          <div className="d-flex justify-content-center mt-3 mb-5">
            <button
              onClick={handlePayFastFormSubmit}
              type="submit"
              style={{ width: "fit-content" }}
              className="btn mt-3 fw-primary model_loginBTn px-4 py-1 fw-500 fs-5 "
              disabled={tokenLoading !== true}
            >
              Proceed to payment
            </button>
          </div>
        </div>

        <Modal
          open={openFaildModal}
          onClose={() => setOpenFaildModal(false)}
          disableAutoFocus={true}
        >
          <Box className="text-center successModal" sx={successModal}>
            <div className="text-center py-2">
              <h2 className="color-secondary">Payment Canceled</h2>
            </div>
            <p className="m-0 p-0">{paymentResponse?.responseMessage}</p>
          </Box>
        </Modal>
        <Modal
          open={openWaitingModal}
          onClose={() => setOpenWaitingModal(false)}
          disableAutoFocus={true}
        >
          <Box className="text-center successModal" sx={successModal}>
            <div className="text-center py-2">
              <Lottie style={{ height: 200 }} animationData={Waiting} loop />
              <h2 className="color-secondary">Wait</h2>
            </div>
            <p className="pt-1">Do not close this window.</p>
          </Box>
        </Modal>
        <Modal
          open={featurePackageSuccess}
          onClose={() => setFeaturePackageSuccess(false)}
          disableAutoFocus={true}
        >
          <Box className="text-center successModal" sx={successModal}>
            <div className="text-center py-2">
              <img
                src={Confirm}
                className="mb-4"
                alt="confirm"
                srcSet={Confirm}
              />
              <h2 className="color-secondary">Success</h2>
            </div>
            <p className="pt-1">
              Your ad has been featured for the next 7 days.
            </p>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default BoostAd;
